<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="ruleAccessForm">
		<!-- ROW * -->
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="newShowErrors(this.f.contacts,'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'label')">{{ 'LIST_CONTACT' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'borderInput')">
						<p-multiSelect formControlName="contacts" [options]="listContactsAll" appendTo="body" dataKey="ObjId"
							[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
							<ng-template let-contacts pTemplate="selectedItems">
								<span *ngFor="let contact of contacts;">
									<span class="font-medium text-0">{{ contact.Name }}, </span>
								</span>
							</ng-template>
							<ng-template let-contactItem pTemplate="item">
								<div class="item">
									<div>{{ contactItem.Name }} - {{ contactItem.Description }}</div>
								</div>
							</ng-template>
						</p-multiSelect>
					</div>
				</div>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="newShowErrors(this.f.contacts,'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'label')">{{ 'LIST_KEYPAD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'borderInput')">
						<p-multiSelect formControlName="keypads" [options]="listKeypadsAll" appendTo="body" dataKey="ObjId"
							[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
							<ng-template let-keypads pTemplate="selectedItems">
								<span *ngFor="let keypad of keypads;">
									<span class="font-medium text-0">{{ keypad.Code }}, </span>
								</span>
							</ng-template>
							<ng-template let-keypadItem pTemplate="item">
								<div class="item">
									<div>{{ keypadItem.Code }} - {{ keypadItem.Description }}</div>
								</div>
							</ng-template>
						</p-multiSelect>
					</div>
				</div>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="newShowErrors(this.f.contacts,'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'label')">{{ 'LIST' | translate }} {{ 'MANAGE_TAGS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.contacts,'borderInput')">
						<p-multiSelect formControlName="tags" [options]="listTagsAll" appendTo="body" dataKey="ObjId"
							[ngClass]="dynamicInputTextWidth()" [styleClass]="dynamicInputTextWidth()"
							selectedItemsLabel="{{'SELECTED_ITEM' | translate }}{0}">
							<ng-template let-tags pTemplate="selectedItems">
								<span *ngFor="let tag of tags;">
									<span class="font-medium text-0">{{ tag.Code }}, </span>
								</span>
							</ng-template>
							<ng-template let-tagItem pTemplate="item">
								<div class="item">
									<div>{{ tagItem.Code }} - {{ tagItem.Description }}</div>
								</div>
							</ng-template>
						</p-multiSelect>
					</div>
				</div>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple [disabled]="!ruleAccessForm.valid" label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>